import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'errors'
})
export class ErrorsPipe implements PipeTransform {
  errorArray = [
    {
      errorCode: 'E063',
      modalTitle: 'Your license has expired',
      modalText:
        'Your license has expired, and access to core features is now disabled. Renew your license to restore full functionality.'
    },
    {
      errorCode: 'E077',
      modalTitle: 'Please, update your node firmware.',
      modalText:
        'Your node firmware does not have this capability. Please, update your node firmware (OS and Node Manager) to its latest version.'
    },
    {
      errorCode: 'E103',
      modalTitle: 'Sorry, you do not have the necessary permissions',
      modalText:
        'Your current profile is not authorized to use this functionality. Please contact your administrator for more information.'
    },
    {
      errorCode: 'E104',
      modalTitle: 'Please, upgrade your subscription',
      modalText:
        'Your current subscription doesn\'t support this functionality. Please, contact our sales team to upgrade your plan.'
    },
    {
      errorCode: 'E113',
      modalTitle: 'Upgrade your subscription',
      modalText:
        'You’ve reached the maximum number of nodes allowed on your license. Please, contact our sales team to upgrade your plan.'
    },
    {
      errorCode: 'E114',
      modalTitle: 'Please, upgrade your subscription',
      modalText:
        'Your license does not allow to build images. Please, contact our sales team to upgrade your plan.'
    },
    {
      errorCode: 'E115',
      modalTitle: 'Upgrade your subscription',
      modalText:
        'You’ve reached the maximum number of users allowed on your license. Please, contact our sales team to upgrade your plan.'
    },
    {
      errorCode: 'E194',
      modalTitle: 'Upgrade your subscription',
      modalText:
        'You’ve reached the maximum number of workload allowed on your license. Please, contact our sales team to upgrade your plan.'
    },
    {
      errorCode: 'E995',
      modalTitle: 'Your license will expire soon',
      modalText:
        'Your license will expire on $date. To prevent downtime or restricted access, make sure to renew in advance.'
    },
    {
      errorCode: 'E996',
      modalTitle: 'Upgrade your subscription',
      modalText:
        'You’re about to reach the maximum number allowed by your license. To proceed, please contact your manager.'
    },
    {
      errorCode: 'E997',
      modalTitle: 'Upgrade your subscription',
      modalText:
        'You’re about to reach the maximum number allowed by your license. Please, contact our sales team to upgrade your plan.'
    },
    {
      errorCode: 'E998',
      modalTitle: 'Upgrade your subscription',
      modalText:
        'You’ve reached the maximum number allowed by your license. To proceed, please contact your manager.'
    },
    {
      errorCode: 'E999',
      modalTitle: 'Upgrade your subscription',
      modalText:
        'You’ve reached the maximum number allowed by your license. Please, contact our sales team to upgrade your plan.'
    }
  ];

  transform(
    value: string,
    params?: any,
    ...args: any[]
  ): { errorCode: string; modalTitle: string; modalText: string } {
    let text = this.errorArray.find((error) => error.errorCode === value);
    if (params) {
      text.modalText = text.modalText.replace('$date', params);
    }
    return text
      ? {
          errorCode: text.errorCode,
          modalTitle: text.modalTitle,
          modalText: text.modalText
        }
      : {
          errorCode: '',
          modalTitle: '',
          modalText: ''
        };
  }
}